import { AuxIcon } from "@blk/aladdin-react-components-es";
import Big from "big.js";
import React from "react";
import { getContainerClassName, getGainLossParameters, getLabel } from "../indicator-helper";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
import { useWidgetCurrentGranularity } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
const allowedDecimals = 4;
const { kpi } = language.en.widgets;
export const InsSimplePercentageIndicator = ({ className, newValue, oldValue, variationSettings, signDisplay, sectionId, widgetId }) => {
    const dataGranularity = useWidgetCurrentGranularity(sectionId, widgetId);
    const difference = new Big(newValue)
        .minus(oldValue)
        .round(allowedDecimals)
        .toNumber();
    const containerClassName = getContainerClassName(difference, className), { classNameSuffix, iconState, iconType } = getGainLossParameters(difference, variationSettings.gainLoss);
    return React.createElement("div", { className: containerClassName },
        " ",
        React.createElement("span", { className: `gain-loss-indicator${classNameSuffix}` },
            difference === 0
                ? kpi.noChange
                : numberFormatters(difference, NumberFormatKind.percent, { maximumFractionDigits: difference ? allowedDecimals : 0, signDisplay }),
            iconType && React.createElement(AuxIcon, { state: iconState, type: iconType })),
        " ",
        getLabel(kpi, dataGranularity));
};
